import { createTheme } from '@mui/material/styles';

export const ThemeMain = createTheme({
    palette: {
      primary: {
        main: '#232323',
        light: '#4f4f4f',
        dark: '#181818',
        lighter:'#ededed',
      },
      secondary: {
        main: '#0070FF',
        light: '#338cff',
        dark: '#004eb2',
      },
      gray: {
        main: '#878787',
        light: '#9f9f9f',
        dark: '#5e5e5e',
      },
      cultured: {
        main: '#ebebeb',
        light: '#F5F6FA',
        dark: '#abacaf',
        lighter:'#f7f7fb'
      },
      green: {
        main: '#00AB49',
        light: '#33bb6d',
        dark: '#007733',
      },
      red: {
        main: '#FF4D4F',
        light: '#ff7072',
        lighter: '#ffd9d9',
        dark: '#b23537',
      },
      yellow: {
        main: '#ffb207',
        light: '#ffc138',
        dark: '#b27c04',
      },
      purple: {
        main: '#8B54FF',
        light: '#a276ff',
        dark: '#613ab2',
      },
      white: {
        main: '#FFF',
      },
    },
    typography: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontSize: 16
    },
});  

export const ThemeCustom = createTheme({

  typography:{
      text14Light:{
        color: ThemeMain.palette.gray.light,
        fontSize:'0.825rem',
        fontWeight:'500'
      },
      textBase:{
        color: ThemeMain.palette.primary.main,
        fontSize:'1rem',
        fontWeight:'500'
      },
      textBaseLight:{
        color: ThemeMain.palette.gray.light,
        fontSize:'1rem',
        fontWeight:'500'
      },
      textBaseSecondary:{
        color: ThemeMain.palette.secondary.main,
        fontSize:'1rem',
        fontWeight:'500'
      },
      text18Light:{
        color: ThemeMain.palette.gray.light,
        fontSize:'1.125rem',
        fontWeight:'500'
      },
      text20:{
        color: ThemeMain.palette.primary.main,
        fontSize:'1.25rem',
        fontWeight:'500'
      },
      textheader1:{
        color: ThemeMain.palette.primary.main,
        fontSize:'4rem',
        fontWeight:'500'
      },
      textheader2:{
        color: ThemeMain.palette.primary.main,
        fontSize:'2.25rem',
        fontWeight:'600'
      },
      textheader3:{
        color: ThemeMain.palette.primary.main,
        fontSize:'1.5rem',
        fontWeight:'600'
      },
      textheader4:{
        color: ThemeMain.palette.primary.main,
        fontSize:'1.25rem',
        fontWeight:'600'
      },
      textheaderSub2Gray:{
        color: ThemeMain.palette.gray.light,
        fontSize:'1.5rem',
        fontWeight:'600'
      },
      textheaderSub2DarkGray:{
        color: ThemeMain.palette.gray.dark,
        fontSize:'1.5rem',
        fontWeight:'600'
      },
  },    
  components:{
    MuiInputLabel:{
      styleOverrides:{
        root:{
          position:'relative',
          fontSize:'1rem',
          color: ThemeMain.palette.primary.main,
          fontFamily: ['Inter', 'sans-serif'].join(','),
          fontWeight: 500,
          transform:'inherit',
          marginBottom:'0.5rem',
          '&.Mui-focused':{
            color: ThemeMain.palette.primary.main
          }
        }
      }
    },
    MuiOutlinedInput:{
      styleOverrides:{
        root:{
          borderRadius:'0.75rem',
          width:'100%',
          backgroundColor: ThemeMain.palette.cultured.light,
          '&.Mui-focused .MuiOutlinedInput-notchedOutline':{
            borderColor:  ThemeMain.palette.cultured.dark,
            borderWidth: '1px'
          },
          '& .MuiOutlinedInput-notchedOutline':{
            borderWidth: '0'
          },
        },
        input:{
          fontSize: '1rem',
          color: ThemeMain.palette.primary.main,
          fontFamily: ['Inter', 'sans-serif'].join(','),
          fontWeight: 500,
          padding: '0.75rem 1rem'
        }
      }
    },
    MuiFormControl:{
      styleOverrides:{
        root:{
          marginBottom:'1.5rem'
        }
      }  
    },
    MuiButton:{
      variants:[
        {
          props:{variant:'primary'},
          style:{
            color: ThemeMain.palette.white.main,
            backgroundColor: ThemeMain.palette.primary.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.primary.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.primary.light
            }
          }
        },
        {
          props:{variant:'primaryOutline'},
          style:{
            color: ThemeMain.palette.primary.main,
            backgroundColor: ThemeMain.palette.white.main,
            border:`1px solid ${ThemeMain.palette.primary.main}`,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.6875rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.primary.lighter,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.primary.light
            }
          }
        },
        {
          props:{variant:'redOutline'},
          style:{
            color: ThemeMain.palette.red.main,
            backgroundColor: ThemeMain.palette.white.main,
            border:`1px solid ${ThemeMain.palette.red.main}`,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.6875rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.red.lighter,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.red.light
            }
          }
        },
        {
          props:{variant:'secondary'},
          style:{
            color: ThemeMain.palette.white.main,
            backgroundColor: ThemeMain.palette.secondary.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.secondary.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.secondary.light
            }
          }
        },
        {
          props:{variant:'red'},
          style:{
            color: ThemeMain.palette.white.main,
            backgroundColor: ThemeMain.palette.red.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.red.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.red.light
            }
          }
        },
        {
          props:{variant:'green'},
          style:{
            color: ThemeMain.palette.white.main,
            backgroundColor: ThemeMain.palette.green.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.green.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.green.light
            }
          }
        },
        {
          props:{variant:'cultured'},
          style:{
            color: ThemeMain.palette.primary.main,
            backgroundColor: ThemeMain.palette.cultured.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            fontWeight:'600',
            '&:hover':{
              backgroundColor:ThemeMain.palette.cultured.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.cultured.light
            }
          }
        },
        {
          props:{variant:'culturedLight'},
          style:{
            color: ThemeMain.palette.primary.main,
            backgroundColor: ThemeMain.palette.cultured.light,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            fontWeight:'600',
            '&:hover':{
              backgroundColor:ThemeMain.palette.cultured.main,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.cultured.lighter
            }
          }
        },
        {
          props:{variant:'redIconButton'},
          style:{
            color: ThemeMain.palette.red.main,
            backgroundColor: ThemeMain.palette.white.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.725rem 0.75rem',
            borderRadius:'0.75rem',
            fontWeight:'600',
            '&:hover':{
              backgroundColor:ThemeMain.palette.red.lighter,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.white.main
            }
          }
        },
        {
          props:{variant:'culturedIconButton'},
          style:{
            color: ThemeMain.palette.primary.main,
            backgroundColor: ThemeMain.palette.white.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.725rem 0.75rem',
            borderRadius:'0.75rem',
            fontWeight:'600',
            '&:hover':{
              backgroundColor:ThemeMain.palette.cultured.main,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.white.main
            }
          }
        },
        {
          props:{variant:'purple'},
          style:{
            color: ThemeMain.palette.white.main,
            backgroundColor: ThemeMain.palette.purple.main,
            fontFamily: ['Inter', 'sans-serif'].join(','),
            fontSize: '1rem',
            minWidth:'7.5rem',
            padding: '0.75rem 1.25rem',
            borderRadius:'0.75rem',
            '&:hover':{
              backgroundColor:ThemeMain.palette.purple.dark,
            },
            '&.Mui-disabled':{
              backgroundColor:ThemeMain.palette.purple.light
            }
          }
        },
      ]
    },
    MuiAppBar:{
      styleOverrides:{
        root:{
          backgroundColor: ThemeMain.palette.white.main,
        }
      }
    },
    MuiList:{
      styleOverrides:{
        root:{
          borderRadius: '0.75rem',
          padding:0
        }
      }
    },
    MuiMenuItem:{
      styleOverrides:{
        root:{
          // borderBottom:`1px solid ${ThemeMain.palette.cultured.dark}`,
          padding:'0.75rem 1.25rem',
          minWidth:'9rem',
          '&:last-child':{
            // borderBottom:`0px solid ${ThemeMain.palette.primary.main}`
          }
        }
      }
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          borderRadius:'0.75rem',
          fontSize: '1rem',
          color: ThemeMain.palette.primary.main,
          fontFamily: ['Inter', 'sans-serif'].join(','),
        }
      }
    },
    MuiBackdrop :{
      styleOverrides:{
        root:{
          backgroundColor:'rgba(0, 0, 0, 0.3)'
        }
      }
    },
    MuiTabs :{
      styleOverrides:{
        indicator:{
          display:'none'
        },
        flexContainer:{
          justifyContent:'flex-end'
        }
      }
    },
    MuiTab :{
      styleOverrides:{
        root:{
          backgroundColor:ThemeMain.palette.white.main,
          minWidth:'8rem',
          padding: '1rem',
          fontSize:'1rem',
          textTransform:'none',
          border:`1px solid ${ThemeMain.palette.cultured.main}`,
          borderBottom:`0px solid ${ThemeMain.palette.cultured.main}`,
          color:ThemeMain.palette.primary.main,
          '&:first-of-type':{
            borderRadius:'0.75rem 0 0',
            borderRight:`0px solid ${ThemeMain.palette.primary.main}`,
          },
          '&:last-child':{
            borderRadius:'0 0.75rem 0 0',
            borderLeft:`0px solid ${ThemeMain.palette.primary.main}`,
          },
          '&.Mui-selected':{
            backgroundColor:ThemeMain.palette.secondary.main,
            color:ThemeMain.palette.white.main,
            border:`1px solid ${ThemeMain.palette.secondary.main}`,
          }
        },
        flexContainer:{
          justifyContent:'flex-end'
        }
      }
    },
    MuiTableCell :{
      styleOverrides:{
        root:{
          color:ThemeMain.palette.primary.main,
          fontSize:'1rem',
          fontWeight:'500',
          borderColor: ThemeMain.palette.cultured.main,
        },
        head:{
          fontWeight:'600',
        }
      }
    },
    MuiTableRow :{
      styleOverrides:{
        root:{
          '&:last-child td': { 
            border: 0 
          }
        },
      }  
    },
    MuiTooltip  :{
      styleOverrides:{
        tooltip:{
          color:ThemeMain.palette.white.main,
          backgroundColor:ThemeMain.palette.primary.main,
          fontSize:'0.825rem',
          fontWeight:'500',  
          borderRadius:'0.25rem',      
          marginTop:'0.5rem !important',
          paddingLeft:'0.75rem',
          paddingRight:'0.75rem'
        },
      }  
    }
  }  
})      
